import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { desaturate, math } from 'polished'
import { colors } from 'config/theme'
import { animated, useSpring } from 'react-spring'
import { RAIL_HEIGHT } from '../constants'

const StyledTrack = styled(animated.div)`
  position: absolute;
  transform: translate(0%, -50%);
  height: ${RAIL_HEIGHT};
  ${({ isDisabled }) => `
    background-color: ${
      isDisabled ? desaturate(0.3, colors.brandCta) : colors.brandCta
    }};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
  `}
  border-radius: ${math(`${RAIL_HEIGHT} / 2`)};
`

const Track = React.forwardRef(
  (
    {
      source: { percent: sourcePercent },
      target: { percent: targetPercent },
      ...rest
    },
    ref
  ) => {
    const leftAnimation = useSpring({
      left: `${sourcePercent || 0}%`,
      width: `${targetPercent - sourcePercent}%`,
    })
    return <StyledTrack style={leftAnimation} {...rest} ref={ref} />
  }
)

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

Track.defaultProps = {
  disabled: false,
}

export default Track
